:host {
  --highlight-color: var(--wb-blue-45, #0078d6);
  --variant-color: var(--wb-green-45, #198025);
  --icon-color: var(--variant-color);

  display: block;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 1em;
  margin: 0 auto;
  max-width: 512px;
  min-width: 300px;
  width: fit-content;
  background: var(--wb-grey-15, #262626);
  border: 2px solid var(--variant-color);
  border-color: var(--variant-color);
  border-radius: 4px;
  color: var(--wb-white, #fff);
  box-shadow: 0 0 4px 0 rgb(0 0 0 / 10%), 0 16px 24px 0 rgb(0 0 0 / 10%);
  z-index: 2010;

  .cmm-notification__content {
    font-family: var(--wb-font-text, "MBCorpo Text", "DaimlerCS-Regular", "DaimlerCSArab-Regular", sans-serif);
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5rem;
    margin: 0;
    padding: 16px;
    padding-right: 56px;
  }

  .cmm-notification__button {
    appearance: none;
    background-color: var(--wb-grey-15, #262626);
    border: 1px solid var(--wb-grey-20, #333);
    border-radius: 100%;
    box-shadow: none;
    position: absolute;
    top: 10px;
    right: 10px;
    height: 36px;
    width: 36px;
    color: var(--wb-white, #fff);
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background-color: var(--wb-grey-15, #262626);
      border-color: var(--wb-grey-40, #696969);
    }

    &:focus {
      background-color: var(--wb-grey-15, #262626);
      border-color: var(--highlight-color);
    }
  }
}

[dir="rtl"].cmm-notification {
  .cmm-notification__content {
    padding-left: 56px;
    padding-right: 16px;
  }

  .cmm-notification__button {
    left: 10px;
    right: initial;
  }
}
